<div class="modal-header" appCustomAutofocus>
    <h3 class="modal-title">Edit Long Prompt</h3>
</div>
<div class="modal-body">
    <quill-editor name="text" [(ngModel)]="text" format="html" style="display: block;min-height:200px;"></quill-editor>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="saveClicked()" [disabled]="text == null">Save</button>
    <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()">Cancel</button>
</div>